module.exports = __webpack_public_path__ + "static/img/p11.859524e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p11.png
// module id = 236
// module chunks = 1